export default class GridLayout {

  public w: number;
  public h: number;
  public x: number;
  public y: number;
  public i: any;
  public minW: number;
  public maxW: number;

  constructor(w: number, h: number, x: number, y: number, i: any, minW = 0, maxW = 0) {
    this.w = w;
    this.h = h;
    this.x = x;
    this.y = y;
    this.i = i;
    this.minW = minW === 0 ? w : minW;
    this.maxW = maxW === 0 ? w : maxW;
  }
}
